<template>
  <div>
    <div dir="rtl">
      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_admin.first_name" label="שם פרטי :" />
        </div>
        <div class="column">
          <BaseInput v-model="staged_admin.last_name" label="שם משפחה :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_admin.title" label="תואר :" />
        </div>
        <div class="column">
          <BaseInput v-model="staged_admin.full_name" label="שם מלא :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput
            v-model="staged_admin.office_phone_number"
            label="מספר טלפון במשרד :"
          />
        </div>
        <div class="column">
          <BaseInput v-model="staged_admin.phone_number" label="מספר טלפון :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_admin.website" label="אתר :" />
        </div>
        <div class="column">
          <BaseInput type="color" classString="color" v-model="staged_admin.color" label="צבע :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_admin.common_email" label="אמייל משרד :" />
        </div>
        <div class="column">
          <BaseInput v-model="staged_admin.email" label="*אמייל :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_admin.permission_level" label="הרשאות :" />
        </div>
      </div>

      <div v-if="this.payload.is_create">
        <hr />
        <div class="columns">
          <div class="column">
            <BaseInput
              type="password"
              v-model="staged_admin.password"
              label="סיסמא :"
            />
          </div>
          <div class="column">
            <BaseInput
              type="password"
              v-model="staged_admin.confirmPassword"
              label="אימות סיסמא :"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit(true)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        >הזן ורענן לי את הדף</a
      >
      <a
        @click="submit(false)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        style="margin: 10px"
        >הזן ואל תרענן</a
      >
      <div style="flex-grow: 4" class="rtl">
        <label class="bold">סטטוס:</label>
        <select class="mx-3" v-model="staged_admin.status" dir="rtl">
          <option value="active">active</option>
          <option value="blocked">blocked</option>
          <option value="pending">pending</option>
          <option value="expired">expired</option>
          <option value="test">test</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
// libraries
import { mapActions } from 'vuex'

// components
import BaseInput from '@/components/BaseInput'

// constants
import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/admin_list/types'

export default {
  name: 'admin-list-form',
  props: ['payload'],
  data () {
    return {
      staged_admin: {},
      blank_staged_admin: {
        first_name: '',
        last_name: '',
        full_name: '',
        email: '',
        common_email: 'office@suitup.co.il',
        password: '',
        status: 'active',
        confirmPassword: '',
        title: 'יועצת גיוס והשמה',
        phone_number: '',
        office_phone_number: '03-7767762',
        website: 'https://www.suitup.co.il',
        color: '#828282',
        permission_level: 0
      },
      is_submitting: false,
      is_refresh: false
    }
  },
  async created () {
    this.staged_admin = { ...this.blank_staged_admin }
    if (!this.payload.is_create) {
      try {
        const r = await this.$network_utils.getAdmin({
          id: this.payload.data.id
        })
        this.staged_admin = r
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    ...mapActions(STORE_NAMESPACE, [FETCH_ALL]),
    async upsertData (method) {
      try {
        const r = await this.$network_utils[method](this.staged_admin)
        if (this.refresh) {
          this[FETCH_ALL]()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the following admin: ${r.full_name}`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    },
    submit (refresh) {
      this.refresh = refresh
      for (const [key, value] of Object.entries(this.staged_admin)) {
        if (typeof value === 'string' || value instanceof String) {
          this.staged_admin[key] = value.trim()
        }
      }
      if (this.payload.is_create) {
        if (this.password == this.confirmPassword) {
          this.upsertData('postAdmin')
        } else {
          this.$utils.emit('show_toast', {
            text: 'Password validation fails'
          })
        }
      } else {
        this.upsertData('updateAdmin')
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
